import React, { forwardRef } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import GithubCodeScanMappingFormV2 from './GithubCodeScanMappingFormV2';
import { useFeatureFlag } from "contexts/FeatureFlagContext";

const GithubCodeScanCredentialsForm = forwardRef((props, ref) => {
    const featureFlags = useFeatureFlag();

    const fields = [
        ...(featureFlags.ENABLE_GHAS_FOR_ENTERPRISE ? [{
            name: "apiEndpoint",
            label: "API Endpoint",
            required: true,
            rules: [urlRegexValidator],
        }] : []),
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ];
    return (
        <GenericPullCredentialsForm 
            {...props} 
            ref={ref}
            fields={fields}
            toolDisplayName="GitHub Code Scan"
            versionField={false} 
            initialValue={{ apiEndpoint: 'https://api.github.com' }}
            MappingForm={GithubCodeScanMappingFormV2}
        />
    )
});

export default GithubCodeScanCredentialsForm;